import React, { Component } from 'react';
const firebase = window.firebase;

class DropArea extends Component {
    state = {
        imgUrl: ''
    }

    componentWillMount(){
        firebase.storage().ref().child('images/droppedfile').getDownloadURL().then( url => {
            console.log('URL for the file:', url);
            this.setState({ imgUrl: url })
        })
    }

    handleDrop = e => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];

        const reader = new window.FileReader();
        reader.onload = (event) => {
            console.log('DROPPED FILE CONTENT:', event.target.result);
            this.setState({ imgUrl: event.target.result })
        }
        reader.readAsDataURL(file);

        console.log('FILES DROPPED:', e.dataTransfer.files );
        firebase.storage().ref().child('images').child('droppedfile').put(file).then( s => {
            
            console.log('File uploaded!');
            firebase.storage().ref().child('images/droppedfile').getDownloadURL().then( url => {
                this.setState({ imgUrl: url })
            })


        })
    }
    handleDragOver = e => { e.preventDefault(); }
    render(){
        const { imgUrl } = this.state;
        return (
            <div
                onDrop={ this.handleDrop }
                onDragOver={ this.handleDragOver }
                className="DropArea" style={{
                    border: '5px dashed gray',
                    minHeight: 100
            }}>
                { imgUrl && <img src={imgUrl} /> }
            </div>
        )
    }
}

export default DropArea


// WEBPACK FOOTER //
// ./src/DropArea.js